import React from "react";

import {styled} from "@mui/material/styles";

import {ReactComponent as Chart} from "assets/img/chart.svg";
const StyledSvg = styled(Chart)({
    width: '20px',
    height: '20px',
    'path': {
        stroke: 'currentColor'
    }
});

export default function CategoriesIcon(props) {
    return <StyledSvg {...props} />;
}
